/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateLicenseRequest} from "../model/create-license-request";
import {SimLicense} from "../model/sim-license";

@Injectable({
    providedIn: "root",
})
export class SimLicenseService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Create a new SimLicense, stores it encrypted in the database and reloads all clients.
 */ 

    public createLicense(request: CreateLicenseRequest) {
        return super.post<void>(`/api/License/CreateLicense`, request);
    }
/**
 * Retrieves the decrypted SimLicense.
 */ 

    public getLicense() {
        return super.get<SimLicense>(`/api/License/GetLicense`, );
    }
}